var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-with-banner', {
    attrs: {
      "showFooter": false,
      "isProgressDone": true,
      "fluid": true
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('m-header', {
          attrs: {
            "title": _vm.$t('common.nouns.vehicles'),
            "breadCrumbs": _vm.breadCrumbs,
            "chips": _vm.chips,
            "actions": _vm.actions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        }), _c('fleet-manager-tree-dialog', {
          ref: "dialog",
          on: {
            "confirm": _vm.debounceUpdateTable
          }
        }), _vm.fleetId ? _c('v-row', [_vm.loading ? _c('v-col', [_c('v-skeleton-loader', {
          attrs: {
            "type": "table"
          }
        })], 1) : _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12"
          }
        }, [_c('paginated-table', {
          key: _vm.updateTableKey,
          attrs: {
            "store": _vm.store,
            "headers": _vm.headers,
            "baseQuery": {
              partnerId: _vm.partnerId,
              fleetId: _vm.fleetId
            },
            "predefinedFilter": _vm.predefinedFilter,
            "showSelect": false,
            "controlElements": _vm.controlElements,
            "downloadConfig": _vm.vehicleDownloadConfig
          },
          scopedSlots: _vm._u([{
            key: "item.timestamp.created",
            fn: function fn(_ref) {
              var item = _ref.item;
              return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.timestamp.created)) + " ")];
            }
          }, {
            key: "item.numberplate",
            fn: function fn(_ref2) {
              var item = _ref2.item;
              return [_c('div', [_c('span', {
                staticClass: "font-weight-black mr-1"
              }, [_vm._v(_vm._s(item.numberplate))]), item.ownership ? _c('v-chip', {
                attrs: {
                  "x-small": "",
                  "outlined": ""
                }
              }, [_vm._v(" " + _vm._s(item.ownership ? _vm.$t("enums.VehicleOwnershipStatusEnum.".concat(item.ownership)) : "") + " ")]) : _vm._e()], 1), _c('div', {
                staticClass: "mb-1"
              }, [item.identificationnumber ? _c('small', {
                staticClass: "mr-1",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-car-info ")]), _vm._v(" " + _vm._s(item.identificationnumber) + " ")], 1) : _vm._e(), item.registration.manufacturerName || item.registration.manufacturerDescription ? _c('small', {
                staticClass: "mr-2",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-steering ")]), _c('span', [_vm._v(_vm._s(item.registration.manufacturerName) + " ")]), _c('span', [_vm._v(" " + _vm._s(item.registration.manufacturerDescription) + " ")])], 1) : _vm._e(), item.registration.fuelType ? _c('small', {
                staticClass: "mr-1",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-gas-station-outline ")]), _c('span', [_vm._v(_vm._s(item.registration.fuelType) + " ")])], 1) : _vm._e(), _vm.getInitialRegistrationDate(item) ? _c('small', {
                staticClass: "mr-1",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-calendar-month-outline ")]), _c('span', [_vm._v(_vm._s(_vm.getInitialRegistrationDate(item)) + " ")])], 1) : _vm._e()]), item.note ? _c('div', {
                staticClass: "vehicle-note mb-1"
              }, [_vm._v(" " + _vm._s(item.note) + " ")]) : _vm._e()];
            }
          }, {
            key: "item.state",
            fn: function fn(_ref3) {
              var item = _ref3.item;
              return [item.state ? _c('v-chip', {
                attrs: {
                  "x-small": "",
                  "color": _vm.getState(item).color,
                  "dark": ""
                }
              }, [_vm._v(" " + _vm._s(_vm.i18n["state"][item.state]) + " ")]) : _vm._e()];
            }
          }], null, false, 4278953527)
        })], 1)], 1) : _c('v-row', [_c('v-col', [_c('error-card', {
          on: {
            "reload": function reload($event) {
              return _vm.$router.push({
                name: 'FleetHomeView'
              });
            }
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }